import { NOTIFICATIONS_URL } from "@shared/constants";
import { _getFindingsParamsFromSearch } from "@shared/utils";

import { authPost } from "../auth/auth";

export type CreateNangoTicketsRequest = {
  deploymentId: number;
  ticketingId: string;
  multiIssueTickets: boolean;
  issueIds?: number[];
  searchParams?: URLSearchParams;
  projectId?: string;
};

type CreateNangoTicketsBody = { issue_ids: number[] } | undefined;

export type CreateNangoTicketsResponse = {
  failed: {
    error: string;
    issue_ids: number[];
  }[];
  succeeded: {
    ticket_id: number;
    ticket_url: string;
    issue_ids: number[];
    external_slug: string;
  }[];
  skipped: { issue_ids: number[]; reason: string }[];
};

export const createNangoTickets = async (
  options: CreateNangoTicketsRequest
) => {
  let queryParams = new URLSearchParams();
  if (options.searchParams) {
    // Clean up search params
    queryParams = _getFindingsParamsFromSearch(options.searchParams);
  }
  if (queryParams.get("tab") === null) {
    queryParams.set("tab", "open");
  }

  if (options.projectId) {
    queryParams.set("project_id", options.projectId);
  }

  queryParams.set("group_issues", options.multiIssueTickets.toString());

  return authPost<CreateNangoTicketsBody, CreateNangoTicketsResponse>(
    `${NOTIFICATIONS_URL}/${options.deploymentId}/ticketing/v2/${
      options.ticketingId
    }/create_tickets?${queryParams.toString()}`,
    options.issueIds ? { issue_ids: options.issueIds } : undefined
  );
};
